import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../lib/hook";
import { FormProps, useForm } from "antd/es/form/Form";
import { ICustomer } from "../../../../lib/features/customers/customers.constant";

import { onAddCustomer } from "../../../../lib/features/customers/customers.thunk";
import { Button, Form, Input, Modal } from "antd";

interface ModalAddCustomerProps {
  visible: boolean;
  onClose: () => void;
}

const ModalAddCustomer: React.FC<ModalAddCustomerProps> = (
  props: ModalAddCustomerProps
) => {
  const dispatch = useAppDispatch();
  const { onClose, visible } = props;
  const [loading, setLoading] = useState(false);
  const [frontCID, setFrontCID] = useState<null | File>(null);
  const [backCID, setBackCID] = useState<null | File>(null);

  const [form] = useForm();
  const onFinish: FormProps<ICustomer>["onFinish"] = async (values) => {
    setLoading(true);
    const formData = new FormData();

    // Thêm các field text nếu có
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    });

    // Thêm file nếu có
    if (frontCID) {
      formData.append("frontCID", frontCID);
    }
    if (backCID) {
      formData.append("backCID", backCID);
    }

    await dispatch(onAddCustomer(formData)).then((result) => {
      if (result?.type.includes("fulfilled")) {
        form.resetFields();
        onClose && onClose();
        setLoading(false);
      }
    });

    setLoading(false);
  };
  useEffect(() => {
    if (visible) {
      return () => {
        form.resetFields();
        setBackCID(null);
        setFrontCID(null);
        setLoading(false);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  return (
    <Modal
      loading={loading}
      title="Thêm khách hàng"
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
    >
      <Form
        disabled={loading}
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="mt-3"
      >
        <Form.Item<ICustomer>
          label="Tên gợi nhớ"
          name="shortName"
          rules={[{ required: true, message: "Mời điền chỗ trống" }]}
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>
        <Form.Item<ICustomer>
          label="Họ và tên"
          name="fullName"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>
        <Form.Item<ICustomer>
          label="Địa chỉ"
          name="address"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>

        <Form.Item<ICustomer>
          label="Điện thoại chính"
          name="majorPhone"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>
        <Form.Item<ICustomer>
          label="Điện thoại phụ"
          name="minorPhone"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>

        <Form.Item<ICustomer>
          label="Email"
          name="email"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>
      </Form>

      {/* <div className="grid grid-cols-1 gap-2 mt-2">
        {[
          {
            label: "CCCD mặt trước",
            file: frontCID,
            setFile: setFrontCID,
          },
          {
            label: "CCCD mặt sau",
            file: backCID,
            setFile: setBackCID,
          },
        ].map(({ label, file, setFile }, index) => (
          <div
            key={index}
            className="flex flex-col md:flex-row  gap-2"
          >
            <p className="min-w-[30%]">{label}</p>
            <div className="flex flex-col gap-2 w-full border rounded-md p-2">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const selectedFile = e.target.files?.[0];
                  if (selectedFile && selectedFile.type.startsWith("image/")) {
                    setFile(selectedFile);
                  } else {
                    alert("Vui lòng chọn đúng định dạng ảnh.");
                    e.target.value = ""; // reset input
                  }
                }}
              />
              {file && (
                <div className="flex flex-col gap-2">
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`preview-${label}`}
                    className="w-36 h-36 object-cover rounded border border-gray-300"
                  />
                  <Button onClick={() => setFile(null)} danger>
                    Xóa
                  </Button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div> */}
    </Modal>
  );
};

export default ModalAddCustomer;
